import { createFileRoute } from "@tanstack/react-router";
import { ProductCatalogue } from "~/components/product";
import { Shell } from "~/components/site-shell";
import { breadcrumbs, jsonLd, seoHead } from "~/config/seo";

export const Route = createFileRoute("/products/")({
  head: () => ({
    ...seoHead({
      title: "Products | HostRight",
      description:
        "A growing line-up of practical hosting products from HostRight.",
      path: "/products",
    }),
    scripts: [
      jsonLd(
        breadcrumbs([
          { name: "Home", path: "/" },
          { name: "Products", path: "/products" },
        ]),
      ),
    ],
  }),
  component: ProductsIndex,
});

function ProductsIndex() {
  return (
    <Shell>
      <section className="paper-grid">
        <div className="mx-auto max-w-7xl px-5 py-22 lg:px-12">
          <p className="eyebrow text-moss">HostRight products</p>
          <h1 className="display mt-4 max-w-3xl text-6xl font-bold leading-[.9]">
            A good home for your website.
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-ink/60">
            Simple plans, useful features, and dependable hosting for the sites
            that keep your business moving.
          </p>
        </div>
      </section>
      <ProductCatalogue />
    </Shell>
  );
}
